import * as Sentry from '@sentry/react';
import { useRouteError } from 'react-router-dom';

import styles from './ErrorBoundary.module.scss';

export default function ErrorBoundary() {
  const error = useRouteError() as { status?: number };

  if (error.status === 404) {
    return (
      <div className={styles.errorBoundary}>
        <h1>Página no encontrada</h1>
        <p>
          Esta página no existe. Volver a la <a href="/">página de inicio</a>.
        </p>
      </div>
    );
  }

  Sentry.setTag('route', window.location.pathname);
  Sentry.setTag('fullRoute', window.location.href);
  Sentry.setExtra('error', error);
  Sentry.captureException(error);

  return (
    <div className={styles.errorBoundary}>
      <h1>Algo salió mal</h1>
      <p>Intente actualizar la página o contacte con el administrador.</p>
    </div>
  );
}
